intra_module.factory('Cache', function($cacheFactory) {
    const cache = $cacheFactory('cache');

    cache.refresh = function(context, data) {
        cache.remove(context);
        cache.put(context, data);
        return cache.get(context);
    };

    return cache;
});
